<div *ngIf="importConfig != undefined" class="modal active">
    <div class="modal__container" [ngClass]="[activeFieldsConfig || activeChannel1 || activeChannel2 || activeChannel3 || activeChannel4 || activeInputData || activeOutputData? '' : 'modal__container--md']">
      <div class="fields">
        <h2>Processing Tool Format Options</h2>
        <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
          <div class="fields__container__tabs">
            <div class="fields__container__tabs__item">
              <a href="#" data-tab="1" (click)="activateImportConfig();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeImportConfig ? 'active' : ''">Import Configuration</a>
              <a *ngIf="fileFormat == 'EDS 300'" href="#" data-tab="1" (click)="activateSot();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeSot ? 'active' : ''">SoT</a>
              <a *ngIf="fileFormat == 'EDS 300'" href="#" data-tab="1" (click)="activateFlags();$event.stopPropagation(); $event.preventDefault()"  [ngClass]="activeflags ? 'active' : ''">Flags</a>
              <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel1();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel[0]? 'active' : ''">Channel1</a>
              <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel2();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel[1]? 'active' : ''">Channel2</a>
              <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel3();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel[2]? 'active' : ''">Channel3</a>
              <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateChannel4();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeChannel[3]? 'active' : ''">Channel4</a>
              <a *ngIf="fileFormat != 'Aerodata'" href="#" data-tab="1" (click)="activateInputData();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeInputData? 'active' : ''">Input Data</a>
              <a *ngIf="fileFormat == 'Aerodata'" href="#" data-tab="1" (click)="activateInputData();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeInputData? 'active' : ''">Coordinates</a>
              <a href="#" data-tab="1" (click)="activateOutputData();$event.stopPropagation(); $event.preventDefault()" [ngClass]="activeOutputData? 'active' : ''">Output Data</a>
            </div>
          </div>
          <datalist id="my-list">
            <option *ngFor="let navaidString of getNavaidStringOptions()" [value]="navaidString">
          </datalist>
          <form autocomplete="off" #ngForm="ngForm" id="configureImportFlightFile" [ngClass]="[activeImportConfig? 'active' : '']" >
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>File Format</h4>
                  <span> </span>
                </div>
                <div class="dropdown-fields">
                  <div *ngIf="fileFormat != 'Aerodata'">
                    <label for="">Field Separator</label>
                    <select
                        name="fieldSeparator"
                        [(ngModel)]="importConfig.fieldSeparator"
                      >
                        <option value=".">Dot (.)</option>
                        <option value=",">Comma (,)</option>
                        <option value=";">Semicolon (;)</option>
                        <option value="\t">Tab</option>
                        <option value=" ">Space</option>
                      </select>
                  </div>
                </div>
                  <div class="dropdown-fields">
                    <div>
                      <label for="">Thousand Separator</label>
                      <select
                          name="thousandSeparator"
                          [(ngModel)]="importConfig.thousandSeparator"
                          [disabled]="!importConfig.useThousandSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                        </select>
                    </div>
                  </div>
                  <div>
                    <input name="useThousandSeparator" type="checkbox" [(ngModel)]="importConfig.useThousandSeparator" style="margin-right: 5px; top: 1px; position: relative;">
                    <label for="">Use Thousand Separator</label>
                  </div>

                  <div class="dropdown-fields">
                    <div>
                      <label for="">Decimal Separator</label>
                      <select
                          name="decimalSeparator"
                          [(ngModel)]="importConfig.decimalSeparator"
                        >
                          <option value=".">Dot (.)</option>
                          <option value=",">Comma (,)</option>
                          <option value=";">Semicolon (;)</option>
                        </select>
                    </div>
                  </div>
                  <div class="input-fields">
                    <div>
                      <label for="">Data Starting Line</label>
                      <input
                        style="max-width: 112px;"
                        maxlength="5"
                        [(ngModel)]="importConfig.startingLineIndex"
                        type="number"
                        name="dataStartingLine"
                        id="dataStartingLine"
                        required="true"
                      />
                    </div>
                  </div>

              </div>
            </div>
            <div *ngIf="fileFormat != 'Aerodata' && importConfig != null" class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>NavAid</h4>
                  <span> </span>
                </div>
                <input type="text" name="navaidFlightConfig" [(ngModel)]="importConfig.currentChannel" list="my-list"
                [ngModelOptions]="{ updateOn: 'blur' }" [ngStyle]="{'background-color':!validNavaid(importConfig.currentChannel)?'red': '' }">
               <span style="color: red;" class="error" *ngIf="!validNavaid(importConfig.currentChannel)">
                No navaid found with {{importConfig?.currentChannel}}.
               </span>
              </div>
            </div>
            <div *ngIf="fileFormat == 'EDS 300' && importConfig != null" class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>MDME Channel</h4>
                  <span> </span>
                </div>
                <select name="MDMEChannel" [(ngModel)]="importConfig.mdmeChannel">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                </select>
              </div>
            </div>
            <div *ngIf="fileFormat == 'EDS 300' && importConfig != null" class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Filters</h4>
                  <span> </span>
                </div>
                <div>
                  <input type="checkbox" name="sotFilters" [checked]="importConfig.isSoTsEnabled">
                  <label>SoT Filter</label>
                </div>
                <div>
                  <input type="checkbox" name="flagFilters" [checked]="importConfig.isFlagsEnabled">
                  <label>Flags Filter</label>
                </div>
              </div>

            </div>
            <div *ngIf="fileFormat == 'Aerodata'  && importConfig != null" class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Channels</h4>
                  <span> </span>
                </div>
                <div *ngFor="let channel of importConfig.channels; let i = index">
                  <input
                    style="margin-right: 5px;"
                    type="radio"
                    name="channelRadioGroup"
                    [value]="i"
                    [(ngModel)]="selectedChannelIndex"
                    (change)="selectChannel(i)"
                  >
                  
                  <input
                    type="text"
                    name="channelname__{{i}}"
                    [(ngModel)]="channel.navaidId"
                    [disabled]="!channel.isUsed"
                    list="my-list"
                    [ngStyle]="{'background-color': !validChannel(channel) ? 'red' : ''}"
                  >

                  <span style="color: red;" class="error" *ngIf="!validChannel(channel)">
                    No navaid found with {{channel.navaidId}}.
                  </span>
                </div>
            </div>
            </div>
          </form>
          <form autocomplete="off"  #ngForm="ngForm" id="configureInputData" [ngClass]="[activeInputData? 'active' : '']">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>File Format</h4>
                  <span> </span>
                </div>
                <div class="table-fields">
                  <div style="overflow-y: scroll; height: 237px;">
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Use</th>
                          <th scope="col">Name</th>
                          <th scope="col">Units</th>
                          <th scope="col">Index</th>
                          <th scope="col">Style</th>
                        </tr>
                      </thead>
                        <tbody>
                          <ng-container *ngFor="let el of importConfig.fileFormatElements; let i = index">
                            <tr *ngIf="el.isWietzeToolRequired && !(fileFormat != 'CSV'  && el.key == 'COM_6')">
                              <td>
                                <input id="chk_{{i}}" name="chk_{{i}}"
                                type="checkbox" [(ngModel)]="el.isUsed" [disabled]="el.isUsed ? true : false"/>
                              </td>
                              <td>{{el.displayName}}</td>
                              <td *ngIf="!(el.key != 'COM_6' && el.key != 'ED_6' && el.key != 'COM_4')">
                                <select *ngIf="el.key == 'COM_6'" name="unitsMeasuredPowerLevel" [(ngModel)]="el.units">
                                  <option>[dBm]</option>
                                  <option>[dBW]</option>
                                  <option>[dBW/m2]</option>
                                </select>
                                <select *ngIf="el.key == 'COM_4'" name="unitsAltitude" [(ngModel)]="el.units">
                                  <option>[ft]</option>
                                  <option>[m]</option>
                                </select>
                                <select *ngIf="el.key == 'ED_6'" name="unitsPeakLevel" [(ngModel)]="el.units">
                                  <option>[dBm]</option>
                                  <option>[dBW]</option>
                                </select>
                              </td>
                              <td *ngIf="el.key != 'COM_6' && el.key != 'ED_6' && el.key != 'COM_4'" > {{el.units}} </td>
                              <td>
                                <input id="index_{{i}}" required="true"
                                name="index_{{i}}"
                                [(ngModel)]="el.columnIndex"/>
                              </td>
                              <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="openStyleOfField(i, true)">Define</button></div></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form autocomplete="off"  #ngForm="ngForm" id="configureOutputData" [ngClass]="[activeOutputData? 'active' : '']">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>File Format</h4>
                  <span> </span>
                </div>
                <div class="table-fields">
                  <div style="overflow-y: scroll; height: 237px;">
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Use</th>
                          <th scope="col">Name</th>
                          <th scope="col">Units</th>
                          <th scope="col">Style</th>
                        </tr>
                      </thead>
                        <tbody>
                          <ng-container *ngFor="let el of defaultConfig.fileFormatElements; let i = index">
                            <tr *ngIf="el.isWietzeToolRequired && (el.key == 'PP_3' || el.key == 'PP_4' || el.key == 'PP_5')">
                              <td>
                                <input id="chk_{{i}}" name="chk_{{i}}"
                                type="checkbox" [(ngModel)]="el.isUsed" [disabled]="el.isUsed ? true : false"/>
                              </td>
                              <td>{{el.displayName}}</td>
                              <td>{{el.units}}</td>
                              <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="openStyleOfField(i, false)">Define</button></div></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form autocomplete="off" #ngForm="ngForm" id="configureSoT" [ngClass]="[activeSot? 'active' : '']">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>SoTs</h4>
                  <span> </span>
                </div>
                <div class="table-fields">
                  <div style="overflow-y: scroll; height: 237px;">
                    <table>

                      <thead>
                        <tr>
                          <th scope="col">Use</th>
                          <th scope="col">Name</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let elem of importConfig.sots; let i = index">
                          <td>
                            <input type="checkbox" name="UseSOT_{{i}}" [(ngModel)]="elem.isUsed">
                          </td>
                          <td>{{elem.name}}</td>
                          <td>
                            <div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" (click)="editSoTStyle(i)">Define</button></div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form autocomplete="off" #ngForm="ngForm" id="configureFlags" [ngClass]="[activeflags? 'active' : '']">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Flags</h4>
                  <span> </span>
                </div>
                <div class="table-fields">
                  <div style="overflow-y: scroll; height: 237px;">
                    <table>

                      <thead>
                        <tr>
                          <th scope="col">Use</th>
                          <th scope="col">Flag</th>
                          <th scope="col">Description</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let elem of importConfig.flags; let i = index">
                          <td>
                            <input type="checkbox" name="UseFlag_{{i}}" [(ngModel)]="elem.isUsed">
                          </td>
                          <td>{{elem.letter}}</td>
                          <td>{{elem.description}}</td>
                          <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" style="margin-right: 0px;" (click)="editFlagStyle(i)">Define</button></div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form *ngFor="let channel of importConfig.channels;let c = index" autocomplete="off" #ngForm="ngForm" id="configureFlags" [ngClass]="[activeChannel[c]? 'active' : '']">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Channel Fields</h4>
                  <span> </span>
                </div>
              <div class="table-fields">
                  <div style="overflow-y: scroll; height: 237px;">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Use</th>
                          <th scope="col">Name</th>
                          <th scope="col">Units</th>
                          <th scope="col">Index</th>
                          <th scope="col">Style</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let el of this.getChannel(c).columns ;let i = index">
                          <tr *ngIf="el.isWietzeToolRequired">
                            <td>
                              <input id="chk_{{i}}" name="chk_{{i}}"
                              type="checkbox" [(ngModel)]="el.isUsed"/>
                            </td>
                            <td>{{el.name}}</td>
                            <td>{{el.units}}</td>
                            <td>
                              <input id="index_{{i}}" required="true"
                              name="index_{{i}}"
                              [(ngModel)]="el.index"/>
                            </td>
                            <td><div class="btn" style="justify-content: center;"><button style="margin-right: 0px;" *ngIf="el.hasStyle" (click)="editChannelStyle(c, i)">Define</button></div></td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
              </div>
              </div>
            </div>
          </form>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid" (click)="ok()" >
              OK
            </button>
            <button class="blue" (click)="restoreDefault()">Restore Default</button>
            <button class="gray" (click)="close()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>

